import { Box, Typography } from "@material-ui/core";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import { FC } from "react";
import { ErrorBoundary, FallbackProps } from "react-error-boundary";

const DefaultErrorComponent: FC<FallbackProps> = () => {
  return (
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", padding: 8 }}>
      <ErrorOutlineIcon color="error" fontSize="small" />
      <Box mx={1}>
        <Typography color="textSecondary">Error</Typography>
      </Box>
    </Box>
  );
};

const ErrorCatcher: FC = ({ children }) => {
  const handleOnError = (error: Error, info: { componentStack: string }) => {
    console.log(error.message);
    console.log(info.componentStack);
  };

  return (
    <ErrorBoundary FallbackComponent={DefaultErrorComponent} onError={handleOnError}>
      {children}
    </ErrorBoundary>
  );
};

export default ErrorCatcher;
